export const movieList = [
  {
    id: "m1",
    title: "山海之约",
    type: "movie",
    year: 2024,
    region: "国内",
    genres: ["奇幻", "剧情"],
    rating: 8.6,
    views: 1286000,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20of%20misty%20mountains%20and%20a%20glowing%20peach%20tree%2C%20warm%20amber%20and%20peach%20tones%2C%20elegant%20minimal%20composition%2C%20soft%20ambient%20light%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20ancient%20misty%20mountain%20range%20with%20golden%20sunrise%20light%20and%20floating%20petals%2C%20warm%20peach%20and%20amber%20palette%2C%20atmospheric%20depth%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a1b&orientation=landscape",
    synopsis: "一位守护古老桃林的少女，在山海边界邂逅了来自远方的旅人。",
    description:
      "《山海之约》讲述了守林少女阿禾在桃林深处发现一枚会发光的果子，从而卷入山海两界的百年之约。为了阻止山界崩塌，她与旅人少年同行，穿越迷雾山谷与萤火之森，逐步揭开自己身世之谜。影片以东方奇幻世界观为底色，用温暖的画面与克制的叙事，探讨守护、离别与重逢的意义。",
    director: "沈知远",
    cast: ["林晚", "顾行舟", "苏禾"],
    releaseDate: "2024-08-16",
  },
  {
    id: "m2",
    title: "霓虹追踪",
    type: "movie",
    year: 2023,
    region: "欧美",
    genres: ["动作", "犯罪"],
    rating: 8.1,
    views: 1682000,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20rain%20soaked%20neon%20city%20street%20at%20night%2C%20teal%20and%20orange%20night%20lights%2C%20moody%20atmospheric%20composition%2C%20dramatic%20contrast%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20neon%20lit%20city%20avenue%20at%20night%20with%20reflections%20on%20wet%20asphalt%2C%20moody%20thriller%20atmosphere%2C%20warm%20and%20cool%20light%20contrast%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a2b&orientation=landscape",
    synopsis: "一名退役警探为追查旧案，重新走进霓虹笼罩的夜色都市。",
    description:
      "退役警探马库斯本以为可以远离喧嚣，却在收到一卷匿名录像带后重新出山。他沿着霓虹闪烁的街道一路追踪，发现案件背后牵扯着整座城市的灰色交易。影片用冷冽的夜景与凌厉的剪辑，塑造出一场关于真相与代价的追踪之旅。",
    director: "A. Whitfield",
    cast: ["Marcus Bell", "Elena Poe", "Ryan Cole"],
    releaseDate: "2023-11-03",
  },
  {
    id: "m3",
    title: "春日信箱",
    type: "movie",
    year: 2024,
    region: "日韩",
    genres: ["爱情", "剧情"],
    rating: 8.4,
    views: 943000,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20of%20a%20small%20post%20box%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20warm%20peach%20light%2C%20delicate%20minimal%20composition%2C%20gentle%20spring%20atmosphere%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20village%20lane%20with%20cherry%20blossoms%20falling%20over%20an%20old%20post%20box%2C%20warm%20spring%20sunlight%2C%20soft%20bokeh%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a3b&orientation=landscape",
    synopsis: "两个陌生人因错投的信件相识，在一整个春天里彼此靠近。",
    description:
      "小镇邮局的旧信箱里，每周都会出现一封投错地址的信。整理信件的少女由美与写信的青年在文字往来间渐渐熟悉，却始终未曾见面。随着春天走到尽头，他们终于约定在樱花树下相见。影片以细腻的日常与温柔的光影，讲述一段克制而动人的春日恋曲。",
    director: "中村悠",
    cast: ["佐藤由美", "小林凉", "高桥纱"],
    releaseDate: "2024-04-12",
  },
  {
    id: "m4",
    title: "深蓝回响",
    type: "movie",
    year: 2023,
    region: "国内",
    genres: ["科幻", "悬疑"],
    rating: 8.3,
    views: 1455000,
    cover:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20mystery%20movie%20poster%20of%20a%20lone%20figure%20facing%20deep%20ocean%20trench%20with%20glowing%20particles%2C%20deep%20teal%20and%20warm%20amber%20accents%2C%20minimal%20dramatic%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20deep%20sea%20research%20station%20window%20looking%20into%20dark%20abyss%20with%20faint%20glowing%20lights%2C%20moody%20atmospheric%20sci%20fi%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a4b&orientation=landscape",
    synopsis: "深海观测站接连收到不明回响，一名工程师决定潜入无人区。",
    description:
      "深海观测站「回声」连续三个月记录到规律的低频信号。工程师周野在研究数据时发现，信号似乎指向一段被抹去的旧任务。她独自乘坐潜行器潜入海沟深处，在幽暗的蓝色中，遇见了远超想象的答案。影片以紧张的氛围和克制的科幻设定，探讨记忆与真相。",
    director: "程确",
    cast: ["周野", "陆则", "陈默"],
    releaseDate: "2023-09-22",
  },
  {
    id: "m5",
    title: "午夜面包店",
    type: "movie",
    year: 2022,
    region: "日韩",
    genres: ["剧情", "治愈"],
    rating: 8.7,
    views: 812000,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20healing%20drama%20movie%20poster%20of%20a%20cozy%20bakery%20shop%20glowing%20at%20midnight%2C%20golden%20breads%20and%20soft%20lamps%2C%20warm%20peach%20tones%2C%20intimate%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20a%20small%20warm%20bakery%20at%20midnight%20with%20fresh%20bread%20and%20soft%20golden%20light%2C%20cozy%20nostalgic%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a5b&orientation=landscape",
    synopsis: "只在午夜开门的面包店，为每位深夜到访的客人烤一份心愿。",
    description:
      "巷子深处的面包店只在午夜亮灯，店主会根据客人的故事烤出不同的面包。加班到深夜的上班族、迟迟不肯回家的学生、失去方向的老人，在这里短暂停留，也重新找回前行的勇气。影片用一块块温热的面包，熬煮出都市里最柔软的善意。",
    director: "森田和",
    cast: ["松下彩", "阿部宽太", "井上真"],
    releaseDate: "2022-12-09",
  },
  {
    id: "m6",
    title: "铁轨尽头",
    type: "movie",
    year: 2021,
    region: "欧美",
    genres: ["剧情", "公路"],
    rating: 7.9,
    views: 566000,
    cover:
      "https://readdy.ai/api/search-image?query=Road%20movie%20poster%20of%20an%20old%20railway%20track%20running%20toward%20a%20distant%20horizon%20at%20golden%20hour%2C%20warm%20dusty%20tones%2C%20wide%20minimal%20composition%2C%20nostalgic%20atmosphere%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20endless%20railway%20tracks%20crossing%20dry%20golden%20plains%20at%20sunset%2C%20lonely%20road%20trip%20atmosphere%2C%20warm%20amber%20light%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a6b&orientation=landscape",
    synopsis: "一对久别的父女沿着废弃铁轨出发，寻找记忆里的终点站。",
    description:
      "父亲带着多年未见的女儿，开着一辆旧皮卡沿着废弃的铁轨一路向西。他们穿过荒原、小镇与旧车站，在漫长的旅途中重新学习如何相处。影片以公路片的形式，讲述一段关于和解与告别的旅程。",
    director: "J. Harrow",
    cast: ["Daniel Reed", "Sophie Reed", "Tom Ellis"],
    releaseDate: "2021-06-18",
  },
  {
    id: "m7",
    title: "雾都迷案",
    type: "movie",
    year: 2024,
    region: "国内",
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    views: 1338000,
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20crime%20movie%20poster%20of%20a%20foggy%20old%20city%20street%20with%20a%20lone%20lamp%20and%20silhouette%2C%20muted%20warm%20sepia%20tones%2C%20mysterious%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20fog%20covered%20historic%20city%20street%20at%20dusk%20with%20faint%20street%20lamps%2C%20moody%20mystery%20atmosphere%2C%20warm%20muted%20palette%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a7b&orientation=landscape",
    synopsis: "雾气笼罩的旧城接连发生怪案，一名记者循着线索深入调查。",
    description:
      "旧城入冬后大雾不散，几起看似无关的案件陆续发生。记者沈砚在采访中察觉到它们之间的隐秘关联，独自展开调查。随着真相逐渐浮出水面，她发现最深的雾，其实藏在人心之中。",
    director: "韩牧",
    cast: ["沈砚", "叶知秋", "陆岩"],
    releaseDate: "2024-03-29",
  },
  {
    id: "m8",
    title: "星际摆渡人",
    type: "movie",
    year: 2022,
    region: "欧美",
    genres: ["科幻", "冒险"],
    rating: 8.5,
    views: 1874000,
    cover:
      "https://readdy.ai/api/search-image?query=Space%20adventure%20movie%20poster%20of%20a%20small%20ferry%20ship%20crossing%20a%20nebula%20with%20warm%20star%20glow%2C%20deep%20space%20minimal%20composition%2C%20cinematic%20scale%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20small%20spacecraft%20drifting%20through%20a%20colorful%20nebula%20with%20warm%20starlight%2C%20epic%20sci%20fi%20scale%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a8b&orientation=landscape",
    synopsis: "末日边缘，最后一艘摆渡船载着希望穿越星海。",
    description:
      "母星资源枯竭后，摆渡人莱恩负责将最后一批居民送往新的家园。漫长航程中，飞船遭遇未知星云与能源危机，他必须在有限的时间里做出艰难的选择。影片以宏大的星际景观，讲述关于责任与希望的故事。",
    director: "N. Kovac",
    cast: ["Liam Cross", "Nora Vance", "Evan Frost"],
    releaseDate: "2022-07-15",
  },
  {
    id: "m9",
    title: "少年与海",
    type: "movie",
    year: 2023,
    region: "国内",
    genres: ["动画", "家庭"],
    rating: 8.6,
    views: 1077000,
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20family%20film%20poster%20of%20a%20small%20boy%20and%20a%20giant%20whale%20under%20warm%20sunset%20sea%2C%20soft%20peach%20and%20turquoise%20tones%2C%20gentle%20minimal%20composition%2C%20hand%20painted%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20wide%20shot%20of%20a%20boy%20on%20a%20wooden%20boat%20beside%20a%20giant%20whale%20at%20golden%20sunset%20sea%2C%20warm%20gentle%20palette%2C%20painterly%20style%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a9b&orientation=landscape",
    synopsis: "渔村少年救下一头落单的鲸鱼，从此有了一段跨越大海的友谊。",
    description:
      "海边小村的少年阿海在一次风暴后救下了一头搁浅的幼鲸。他与鲸鱼约定，每年夏天都在海湾相见。随着村庄变迁与成长到来，阿海不得不面对分别。影片以温暖的手绘风格，讲述童年、自然与守护。",
    director: "白屿",
    cast: ["阿海", "鲸鱼小满", "渔夫爷爷"],
    releaseDate: "2023-07-28",
  },
  {
    id: "m10",
    title: "南方来信",
    type: "movie",
    year: 2021,
    region: "国内",
    genres: ["剧情", "文艺"],
    rating: 7.8,
    views: 421000,
    cover:
      "https://readdy.ai/api/search-image?query=Literary%20drama%20movie%20poster%20of%20an%20old%20southern%20town%20with%20slow%20river%20and%20tiled%20roofs%20in%20warm%20afternoon%20light%2C%20quiet%20nostalgic%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20southern%20riverside%20town%20with%20old%20tiled%20roofs%20in%20warm%20afternoon%20haze%2C%20nostalgic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a10b&orientation=landscape",
    synopsis: "一封迟到了二十年的信，让游子重新回到南方的旧宅。",
    description:
      "在外漂泊多年的策展人收到一封寄自故乡的旧信，信中只有寥寥数语。他回到南方老宅，重新走过童年的街巷，也重新认识了沉默的父亲。影片以缓慢的节奏与温润的色调，书写关于故乡与和解。",
    director: "林砚白",
    cast: ["沈知", "陆晚", "老周"],
    releaseDate: "2021-10-22",
  },
  {
    id: "m11",
    title: "纸飞机计划",
    type: "movie",
    year: 2023,
    region: "日韩",
    genres: ["青春", "剧情"],
    rating: 8.0,
    views: 688000,
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20drama%20movie%20poster%20of%20students%20on%20a%20rooftop%20flying%20paper%20planes%20against%20warm%20sky%2C%20soft%20peach%20and%20sky%20blue%20tones%2C%20hopeful%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20school%20rooftop%20with%20paper%20planes%20flying%20into%20warm%20evening%20sky%2C%20hopeful%20youth%20atmosphere%2C%20soft%20palette%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a11b&orientation=landscape",
    synopsis: "一群高中生用纸飞机传递心愿，约定在毕业前完成一次飞行。",
    description:
      "高三的最后一个学期，五名同学把各自的梦想写在纸飞机上。他们决定一起完成一次真正的滑翔实验，作为毕业礼物。影片用明亮的青春气息，讲述勇气、友谊与关于未来的想象。",
    director: "石井凉",
    cast: ["山本遥", "加藤凛", "中岛纯"],
    releaseDate: "2023-05-19",
  },
  {
    id: "m12",
    title: "回声谷",
    type: "movie",
    year: 2024,
    region: "欧美",
    genres: ["惊悚", "悬疑"],
    rating: 8.0,
    views: 1199000,
    cover:
      "https://readdy.ai/api/search-image?query=Thriller%20mystery%20movie%20poster%20of%20a%20fog%20filled%20valley%20with%20a%20lone%20cabin%20among%20pine%20trees%2C%20muted%20warm%20and%20cold%20contrast%2C%20tense%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-media-a12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20foggy%20pine%20valley%20with%20a%20distant%20lonely%20cabin%20at%20dusk%2C%20tense%20thriller%20atmosphere%2C%20muted%20warm%20highlights%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-media-a12b&orientation=landscape",
    synopsis: "一支测绘队进入无人的山谷，却发现这里的回声不属于任何人。",
    description:
      "测绘队奉命进入偏远山谷绘制地图，队员很快发现，他们的每一句话都会以陌生的声音回来。随着夜幕降临，山谷的回声开始预示尚未发生的事。影片用声音营造压迫感，带来一场关于恐惧与执念的体验。",
    director: "K. Lindqvist",
    cast: ["Anna Berg", "Owen Hale", "Mira Sol"],
    releaseDate: "2024-10-04",
  },
];

export const tvList = [
  {
    id: "t1",
    title: "长安食肆",
    type: "tv",
    year: 2024,
    region: "国内",
    genres: ["古装", "美食"],
    rating: 8.5,
    views: 2103000,
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20costume%20drama%20series%20poster%20of%20an%20ancient%20Chinese%20tavern%20with%20warm%20lantern%20light%20and%20steaming%20dishes%2C%20rich%20peach%20and%20amber%20tones%2C%20elegant%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20bustling%20ancient%20Chinese%20food%20street%20at%20night%20with%20warm%20lanterns%20and%20stalls%2C%20festive%20historical%20atmosphere%2C%20warm%20palette%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b1b&orientation=landscape",
    synopsis: "繁华长安的一间小食肆，用一道菜换一个故事。",
    description:
      "长安东市的小食肆由女掌柜阿棠独自打理。她总能根据客人的心事做出一道恰到好处的菜，也因此听遍了市井与庙堂的故事。剧集以美食为线索，串起一座城的烟火与人情。",
    director: "周慕",
    cast: ["阿棠", "顾九", "洛娘"],
    releaseDate: "2024-06-08",
  },
  {
    id: "t2",
    title: "城市边缘",
    type: "tv",
    year: 2023,
    region: "国内",
    genres: ["都市", "悬疑"],
    rating: 8.2,
    views: 1766000,
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20mystery%20series%20poster%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20long%20shadows%2C%20muted%20warm%20and%20gray%20tones%2C%20tense%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20aerial%20shot%20of%20a%20modern%20city%20at%20dusk%20with%20glowing%20windows%20and%20long%20shadows%2C%20urban%20mystery%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b2b&orientation=landscape",
    synopsis: "城市边缘的老社区里，一件旧案在三名住户间重新掀起波澜。",
    description:
      "即将拆迁的老社区里，三位看似毫无交集的住户因一件旧物被联系在一起。随着往事被一点点拼凑，他们发现每个人都隐藏着与案件相关的秘密。剧集以冷峻的都市影像，讲述普通人的选择与代价。",
    director: "高铭",
    cast: ["陈屿", "林薇", "赵启"],
    releaseDate: "2023-08-11",
  },
  {
    id: "t3",
    title: "晨昏之间",
    type: "tv",
    year: 2024,
    region: "日韩",
    genres: ["爱情", "医疗"],
    rating: 8.4,
    views: 1588000,
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20romance%20series%20poster%20of%20two%20doctors%20in%20a%20hospital%20corridor%20at%20dawn%20light%2C%20soft%20warm%20peach%20and%20clean%20tones%2C%20gentle%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20hospital%20corridor%20at%20dawn%20with%20soft%20warm%20light%20through%20tall%20windows%2C%20calm%20medical%20drama%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b3b&orientation=landscape",
    synopsis: "急诊科里，两个把心事藏进白大褂的人，在晨昏交替中靠近。",
    description:
      "急诊科医生智恩与外科医生允浩在同一间医院值夜班。忙碌的抢救间隙，他们分享同一杯咖啡与各自的疲惫。剧集以医院日常为舞台，讲述关于治愈、理解与陪伴的故事。",
    director: "金敏浩",
    cast: ["韩智恩", "李允浩", "朴秀贤"],
    releaseDate: "2024-02-23",
  },
  {
    id: "t4",
    title: "王座之影",
    type: "tv",
    year: 2022,
    region: "欧美",
    genres: ["奇幻", "史诗"],
    rating: 8.8,
    views: 2890000,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20series%20poster%20of%20a%20dark%20throne%20room%20with%20banners%20and%20torch%20light%2C%20warm%20ember%20and%20deep%20shadow%20tones%2C%20dramatic%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20vast%20medieval%20hall%20with%20torch%20lit%20throne%20and%20long%20shadows%2C%20epic%20fantasy%20atmosphere%2C%20warm%20ember%20palette%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b4b&orientation=landscape",
    synopsis: "七国边境风云再起，一个平民少女被推上权力的中心。",
    description:
      "大陆上的七大势力围绕王座明争暗斗。出身低微的少女艾琳因一次意外被卷入权力漩涡，她必须在忠诚与生存之间做出抉择。剧集以宏大的世界观与复杂的人物关系，描绘权力之下的人性光影。",
    director: "R. Alden",
    cast: ["Erin Vale", "Doran King", "Selene Ash"],
    releaseDate: "2022-04-17",
  },
  {
    id: "t5",
    title: "小巷人家",
    type: "tv",
    year: 2023,
    region: "国内",
    genres: ["家庭", "年代",],
    rating: 8.7,
    views: 1932000,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20family%20series%20poster%20of%20an%20old%20alley%20neighborhood%20with%20bicycles%20and%20hanging%20clothes%20in%20warm%20afternoon%20light%2C%20nostalgic%20peach%20tones%2C%20cozy%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20friendly%20old%20alley%20neighborhood%20in%20warm%20afternoon%20light%20with%20bicycles%20and%20hanging%20laundry%2C%20nostalgic%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b5b&orientation=landscape",
    synopsis: "一条小巷，三代人家，几十年的悲欢日常。",
    description:
      "上世纪的小巷里住着几户普通人家，柴米油盐间藏着最真实的悲喜。剧集从孩子的视角出发，记录邻里之间的扶持、争吵与守望，也记录一座城市在岁月中的变迁。",
    director: "汪立",
    cast: ["何婶", "老赵", "小满"],
    releaseDate: "2023-03-10",
  },
  {
    id: "t6",
    title: "深海信号",
    type: "tv",
    year: 2024,
    region: "欧美",
    genres: ["科幻", "惊悚"],
    rating: 8.3,
    views: 1401000,
    cover:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20thriller%20series%20poster%20of%20a%20submarine%20control%20room%20with%20glowing%20screens%20and%20deep%20ocean%20darkness%20outside%2C%20cool%20tones%20with%20warm%20warning%20lights%2C%20tense%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20a%20submarine%20control%20room%20lit%20by%20screens%20with%20deep%20dark%20ocean%20outside%2C%20tense%20sci%20fi%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b6b&orientation=landscape",
    synopsis: "一艘科考潜艇收到来自海底的信号，全船决定追踪它的来源。",
    description:
      "科考潜艇「深蓝号」在执行任务时截获一段来历不明的信号。船长决定改变航线追查信号源，却逐渐发现船员中有人隐瞒着真相。剧集以幽闭的空间与层层反转，营造紧张的深海惊悚氛围。",
    director: "M. Duarte",
    cast: ["Captain Reyes", "Dr. Lin", "Jonas Pike"],
    releaseDate: "2024-09-13",
  },
  {
    id: "t7",
    title: "南风知我意",
    type: "tv",
    year: 2022,
    region: "国内",
    genres: ["古装", "爱情"],
    rating: 8.1,
    views: 1678000,
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20romance%20series%20poster%20of%20a%20lady%20in%20flowing%20robes%20under%20southern%20wind%20and%20willow%20trees%2C%20soft%20peach%20and%20jade%20tones%2C%20elegant%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20classical%20Chinese%20garden%20with%20willow%20trees%20and%20a%20stone%20bridge%20in%20warm%20morning%20light%2C%20elegant%20romantic%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b7b&orientation=landscape",
    synopsis: "南风起时，将门之女与谋士之间隔着一场无法言明的旧约。",
    description:
      "将门之女沈知意与年轻谋士顾南舟自幼相识，却因家族立场渐行渐远。朝局动荡之际，两人不得不在情义与责任间抉择。剧集以古典美学与细腻情感，书写一段跨越权力的深情。",
    director: "柳湘",
    cast: ["沈知意", "顾南舟", "阿绾"],
    releaseDate: "2022-11-25",
  },
  {
    id: "t8",
    title: "急诊风云",
    type: "tv",
    year: 2024,
    region: "国内",
    genres: ["医疗", "职场"],
    rating: 8.2,
    views: 1524000,
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%20of%20busy%20emergency%20room%20with%20doctors%20rushing%20and%20bright%20lights%2C%20clean%20warm%20tones%2C%20dynamic%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20busy%20hospital%20emergency%20room%20with%20doctors%20and%20nurses%20in%20motion%2C%20urgent%20yet%20warm%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b8b&orientation=landscape",
    synopsis: "急诊科二十四小时不熄灯，每个人都在和时间赛跑。",
    description:
      "新上任的主治医师苏晴带着改革方案进入急诊科，与经验丰富的老主任理念相左。一次次抢救中，年轻的医生们逐渐成长，也理解了这份职业的重量。剧集以真实的急救场景，致敬每一位守护生命的人。",
    director: "方舟",
    cast: ["苏晴", "郑主任", "林小满"],
    releaseDate: "2024-01-19",
  },
  {
    id: "t9",
    title: "东京旧梦",
    type: "tv",
    year: 2023,
    region: "日韩",
    genres: ["剧情", "悬疑"],
    rating: 8.3,
    views: 1287000,
    cover:
      "https://readdy.ai/api/search-image?query=Mystery%20drama%20series%20poster%20of%20a%20narrow%20Tokyo%20backstreet%20at%20night%20with%20warm%20neon%20reflections%2C%20nostalgic%20moody%20tones%2C%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20narrow%20Tokyo%20backstreet%20at%20night%20with%20warm%20neon%20signs%20and%20rain%20reflections%2C%20nostalgic%20mystery%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b9b&orientation=landscape",
    synopsis: "一座旧公寓里，三代人各自守着一个与过去有关的秘密。",
    description:
      "东京老城区的一栋旧公寓即将拆除，管理员的孙女在整理遗物时发现了相册里的合影。她循着照片去探寻，逐渐拼凑出属于三代人的往事。剧集以细腻的笔触，讲述记忆、错过与和解。",
    director: "藤原启",
    cast: ["桥本玲", "佐伯健", "小林澄"],
    releaseDate: "2023-10-06",
  },
  {
    id: "t10",
    title: "边境旅人",
    type: "tv",
    year: 2021,
    region: "欧美",
    genres: ["冒险", "剧情"],
    rating: 8.0,
    views: 902000,
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20drama%20series%20poster%20of%20a%20lone%20traveler%20on%20a%20desert%20border%20crossing%20under%20vast%20warm%20sky%2C%20dusty%20peach%20tones%2C%20wide%20minimal%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20lone%20traveler%20walking%20across%20a%20vast%20desert%20border%20under%20warm%20sky%2C%20adventurous%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b10b&orientation=landscape",
    synopsis: "一名旅人沿着边境线行走，为沿途的陌生人带去口信。",
    description:
      "旅人凯尔接受委托，沿着漫长的边境线为陌生人传递口信。他穿过沙漠、山谷与小镇，每一段相遇都改变着他自己的方向。剧集以公路叙事与辽阔风景，讲述关于信任与归属的故事。",
    director: "S. Whitmore",
    cast: ["Kyle Dunn", "Mira Lang", "Owen Shaw"],
    releaseDate: "2021-09-24",
  },
  {
    id: "t11",
    title: "星空下的约定",
    type: "tv",
    year: 2022,
    region: "日韩",
    genres: ["青春", "奇幻"],
    rating: 8.2,
    views: 1106000,
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20youth%20series%20poster%20of%20two%20friends%20on%20a%20hill%20under%20a%20starry%20night%20sky%20with%20a%20small%20observatory%2C%20soft%20peach%20and%20deep%20blue%20tones%2C%20dreamy%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20hilltop%20observatory%20under%20a%20vast%20starry%20night%20sky%2C%20dreamy%20youth%20fantasy%20atmosphere%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b11b&orientation=landscape",
    synopsis: "天文社的两个人约定，要在流星划过时说出同一个愿望。",
    description:
      "高中天文社里，性格迥异的两人因为一次观测结伴。他们约定每年夏夜都在山顶记录星空，也悄悄许下各自的心愿。剧集以温柔的奇幻底色，描绘青春里最明亮的那段时光。",
    director: "木村彩",
    cast: ["森川遥", "冈田直", "小野彩"],
    releaseDate: "2022-08-05",
  },
  {
    id: "t12",
    title: "江河之上",
    type: "tv",
    year: 2024,
    region: "国内",
    genres: ["历史", "剧情"],
    rating: 8.6,
    views: 1996000,
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20epic%20series%20poster%20of%20a%20grand%20ancient%20river%20with%20a%20fleet%20of%20boats%20at%20sunset%2C%20majestic%20warm%20tones%2C%20wide%20dramatic%20composition%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=peach-tv-b12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20grand%20ancient%20river%20with%20boats%20and%20misty%20banks%20at%20sunset%2C%20majestic%20historical%20atmosphere%2C%20warm%20palette%2C%20editorial%20film%20still%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-tv-b12b&orientation=landscape",
    synopsis: "治水名臣的一生，与一条大河和一个时代的命运相连。",
    description:
      "年轻官员临危受命治理水患，从一介书生成长为一代名臣。剧集以宏阔的历史视野，讲述治河、民生与理想之间的艰难抉择，也刻画了一个时代如何因一条大河而改变。",
    director: "江阔",
    cast: ["沈砚之", "河工老周", "钦差陆"],
    releaseDate: "2024-05-31",
  },
];